import { ReminderList } from './reminders.list';

export default {
  name: 'reminders',
  list: ReminderList
};
